import {fetchLineHaulsContainerDetails} from "../network/InductNetworkAPI";

export const ContainerDetailReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {filter, dispatcher} = action.data;
            fetchLineHaulsContainerDetails(filter, dispatcher)
            return state
        case "LINE_HAUL_DATE_RECEIVED":
            return {...state, ...action.data}
        case "LINE_HAULS_CONTAINER_DATA_RECEIVED":
            return {...state, ...action.data}
        case "EXPAND_CONTAINER_DATA":
            let updatedCells = state.expandableCells;
            if(state.expandableCells.includes(action.data)) {
                updatedCells = state.expandableCells.filter(cell => cell !== action.data)
            } else {
                updatedCells = state.expandableCells.concat(action.data)
            }
            return {...state, expandableCells: updatedCells}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/induct/reducers/ContainerDetailReducer.js